import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'fc-outlined-textarea',
  templateUrl: './fc-outlined-textarea.component.html',
  styleUrls: ['./fc-outlined-textarea.component.scss']
})
export class FcOutlinedTextareaComponent implements AfterViewInit {
  @Input()
  control: FormControl;

  @Input()
  required: boolean;

  @Input()
  label: string;

  @Input()
  hint: number;

  @Output()
  next: EventEmitter<void>;

  @ViewChild('textareaElement', { static: false })
  textareaElement: ElementRef;

  constructor(private renderer: Renderer2) {
    this.next = new EventEmitter<void>();
  }

  public ngAfterViewInit(): void {
    this.adjustTextareaHeight();

    this.control.valueChanges.subscribe(() => {
      this.adjustTextareaHeight();
    });
  }

  private adjustTextareaHeight(): void {
    const textarea: HTMLTextAreaElement = this.textareaElement.nativeElement;
    this.renderer.setStyle(textarea, 'height', textarea.scrollHeight + 'px');
  }
}
